module.exports = __webpack_public_path__ + "z-blue-person-circle-1SB1EUo.svg";